(function () {
  function initExternalCart() {
    const drawer = document.getElementById("external-cart-drawer");
    const overlay = document.getElementById("external-cart-overlay");
    const itemsEl = document.getElementById("external-cart-items");
    const totalEl = document.getElementById("cart-total");

    // 🚨 SI NO EXISTE EL DRAWER, NO HACEMOS NADA
    if (!drawer || !overlay) {
      console.warn("🛒 External cart no disponible en esta página");
      return;
    }

    document
  .getElementById("open-external-cart")
  ?.addEventListener("click", e => {
    e.preventDefault();
    openCart();
  });


    function getCart() {
  const storedCart = JSON.parse(localStorage.getItem("externalCart"));
  const storedCustomer = JSON.parse(localStorage.getItem("checkoutCustomer"));

  return storedCart || {
    customer: storedCustomer || {
      address: "",
      city: "",
      region: "",
      comuna: "",
      direccion: "",
      lat: null,
      lng: null,
    },
    items: []
  };
}

    function updateCartBadge() {
  const badge = document.getElementById("external-cart-badge");
  if (!badge) return;

  const cart = getCart();
  const count = cart.items.reduce((sum, i) => sum + i.qty, 0);

  if (count > 0) {
    badge.textContent = count;
    badge.classList.remove("hidden");
  } else {
    badge.textContent = "0";
    badge.classList.add("hidden");
  }
}






    function saveCart(cart) {
      localStorage.setItem("externalCart", JSON.stringify(cart));
      renderCart();
      updateCartBadge();
    }

    function openCart() {
      drawer.classList.add("open");
      drawer.classList.remove("hidden");
      overlay.classList.remove("hidden");
      document.body.style.overflow = "hidden";
    }

    function closeCart() {
      drawer.classList.remove("open");
      overlay.classList.add("hidden");
       document.body.style.overflow = "";
    }

    (function normalizeCart() {
      const cart = getCart();
      let changed = false;

      cart.items.forEach(item => {
        if (!item.deliveryMethod) {
          console.warn("⚠️ Item sin deliveryMethod:", item);
          item.deliveryMethod = "uber";
          changed = true;
        }
      });

      if (changed) {
        localStorage.setItem("externalCart", JSON.stringify(cart));
      }
    })();



    function renderCart() {
  const cart = getCart();
  itemsEl.innerHTML = "";

  let total = 0;

  if (!cart.items.length) {
    itemsEl.innerHTML = `
      <div class="empty-cart">
        <svg xmlns="http://www.w3.org/2000/svg" shape-rendering="geometricPrecision" text-rendering="geometricPrecision" image-rendering="optimizeQuality" fill-rule="evenodd" clip-rule="evenodd" viewBox="0 0 512 394.688"><path fill="#FB5541" fill-rule="nonzero" d="M133.644 228.234L91.993 77.405a14.395 14.395 0 01-.878-4.967c0-7.964 6.458-14.422 14.422-14.422h204.819c-11.549 19.029-17.325 40.576-17.325 62.121 0 30.672 11.704 61.35 35.11 84.753 19.126 19.127 43.112 30.439 67.98 33.935h-248.62v-.043c-6.307.003-12.096-4.175-13.857-10.548z"/><path fill="#333" d="M352.424 324.199c19.464 0 35.244 15.779 35.244 35.245 0 19.464-15.78 35.244-35.244 35.244-19.466 0-35.245-15.78-35.245-35.244 0-19.466 15.779-35.245 35.245-35.245zm-154.518 0c19.464 0 35.244 15.779 35.244 35.245 0 19.464-15.78 35.244-35.244 35.244-19.466 0-35.245-15.78-35.245-35.244 0-19.466 15.779-35.245 35.245-35.245z"/><path fill="#B73E30" fill-rule="nonzero" d="M189.2 122.517c-.372-5.575 3.846-10.397 9.422-10.768 5.575-.372 10.397 3.846 10.768 9.422l3.625 53.87c.372 5.576-3.846 10.397-9.422 10.769-5.575.371-10.397-3.847-10.769-9.422l-3.624-53.871zm66.294-.673c0-5.598 4.539-10.137 10.137-10.137 5.597 0 10.136 4.539 10.136 10.137v53.87c0 5.598-4.539 10.137-10.136 10.137-5.598 0-10.137-4.539-10.137-10.137v-53.87z"/><path fill="#484848" fill-rule="nonzero" d="M14.419 28.838C6.457 28.838 0 22.381 0 14.419 0 6.457 6.457 0 14.419 0h37.525l1.44.072C66.493.311 78.423 2.88 88.457 9.125c10.982 6.833 19.18 17.494 23.507 33.408 14.579 62.519 34.659 125.137 49.666 187.673 6.259 24.738 11.416 37.474 19.525 42.922 7.077 4.754 18.794 5.766 37.235 5.701 7.5-.023 14.812-.177 22.309-.177h154.328c7.962 0 14.419 6.457 14.419 14.419 0 7.962-6.457 14.419-14.419 14.419H240.022c-7.128 0-14.122.051-21.246.065-24.323.065-40.425-1.683-53.62-10.547-15.288-10.268-23.342-27.714-31.448-59.821l-49.57-187.11c-2.241-8.246-6.016-13.475-10.887-16.505-5.222-3.249-12.178-4.617-20.226-4.775l-1.081.041H14.419z"/><path fill="#333" fill-rule="nonzero" d="M0 14.419C0 6.457 6.457 0 14.419 0h37.525l1.44.072C66.493.311 78.423 2.88 88.457 9.125c10.982 6.833 19.18 17.494 23.507 33.408 14.579 62.519 34.659 125.137 49.666 187.673 6.259 24.738 11.416 37.474 19.525 42.922 7.087 4.761 18.828 5.77 37.317 5.701 7.463-.023 14.74-.177 22.2-.177h154.355c7.962 0 14.419 6.457 14.419 14.419H229.231c-55.159.971-67.194-2.524-81.555-59.376L98.05 46.305c-6.57-24.167-23.913-31.756-46.106-31.886H0z"/><path fill="#333" d="M342.817 50.059c38.702-38.703 101.452-38.703 140.155 0 38.704 38.703 38.704 101.453 0 140.156-38.703 38.703-101.453 38.703-140.155 0-38.704-38.703-38.704-101.453 0-140.156z"/><path fill="#fff" d="M368.988 141.244l65.014-65.014c1.802-1.801 4.767-1.785 6.553 0l16.246 16.246c1.785 1.785 1.787 4.766 0 6.553l-65.015 65.014c-1.787 1.787-4.749 1.803-6.552 0l-16.246-16.246c-1.803-1.803-1.799-4.753 0-6.553z"/><path fill="#fff" d="M391.786 76.228l65.015 65.015c1.789 1.788 1.789 4.763 0 6.552l-16.246 16.246c-1.789 1.789-4.75 1.803-6.553 0l-65.014-65.014a4.644 4.644 0 010-6.552l16.246-16.247c1.803-1.803 4.778-1.774 6.552 0z"/></svg>
        <h3>Tu carrito esta vacío</h3>
        <p>Explora nuestras ofertas y productos locales</p>
        <p>¡Tu mascota te lo agradecera!</p>
        
      </div>
    `;
    totalEl.textContent = "$0";
    return;
  }

cart.items.forEach(item => {
  const price = Number(item.price) || 0;
  const qty = Number(item.qty) || 1;

  total += price * qty;

  itemsEl.insertAdjacentHTML("beforeend", `
    <div class="custom-cart-item" data-sku="${item.sku}">
      <div class="image-wrapper">
        <img src="${item.image}" alt="">
      </div>
      <div class="cart-item-info">
        <strong>${item.title}</strong>

        <div class="cart-item-actions">
          <p class="item-price">$${price.toLocaleString()}</p>

          <div class="cart-item-qty">
            <button class="qty-btn" data-action="decrease">−</button>
            <input
              type="number"
              min="1"
              value="${qty}"
              class="qty-input"
            />
            <button class="qty-btn" data-action="increase">+</button>
          </div>

          <button class="remove-item" title="Eliminar">
            ...
          </button>
        </div>
      </div>
    </div>
  `);
});


  totalEl.textContent = `$${total.toLocaleString()}`;
  updateFreeShippingMessage(total);

}


    document.addEventListener("click", e => {
      const btn = e.target.closest("[data-add-to-external-cart]");
      console.log("que agrega el boton:", btn);
      if (btn) {
        e.preventDefault();
        e.stopPropagation();
        if (!hasSelectedVendor()) {

          const pendingProduct = {
            sku: btn.dataset.sku,
            title: btn.dataset.title,
            price: Number(btn.dataset.price),
            image: btn.dataset.image,
            variantId: btn.dataset.variantId,
            qty: 1
          };

          localStorage.setItem(
            "pendingAddToCart",
            JSON.stringify(pendingProduct)
          );

          console.warn("🕒 Producto pendiente:", pendingProduct);

          openLocationPopup();
          return;
        }


        const cart = getCart();

        const sku = btn.dataset.sku;
        const existing = cart.items.find(i => i.sku === sku);
        const vendorId = localStorage.getItem("currentVendorId") || "CLp6M8ozKCbkg6ffYKhFMqEirMN2";
        const isInternal = btn.dataset.internal === "true";

        if (existing) {
          existing.qty += 1;
        } else {
          const inventory = window.vendorInventory || {};
          const inventoryItem = inventory[btn.dataset.variantId] || null;


         


          cart.items.push({
            sku,
            title: btn.dataset.title,
            price: Number(btn.dataset.price),
            image: btn.dataset.image,
            variantId: btn.dataset.variantId,
            vendorId,
            deliveryMethod: isInternal ? "internal" : "uber",
            qty: 1
          });

        }

        console.table({
  sku: btn.dataset.sku,
  title: btn.dataset.title,
  price: btn.dataset.price,
  image: btn.dataset.image,
  variantId: btn.dataset.variantId,
  deliveryMethod: isInternal
});


        saveCart(cart);
        openCart();
        return;
      }

      
    });

    document.getElementById("close-cart")?.addEventListener("click", e => {
  e.preventDefault();
  closeCart();
});

function updateFreeShippingMessage(total) {
  const el = document.getElementById("free-shipping-message");
  if (!el || !window.freeShipping) return;

  const threshold = Number(window.freeShipping.threshold || 0);
  const template = window.freeShipping.message || "";

  if (!threshold) {
    el.textContent = "";
    return;
  }

  if (total >= threshold) {
    el.textContent = "🎉 ¡Ya tienes envío gratis!";
    el.classList.add("success");
  } else {
    const remaining = threshold - total;
    el.classList.remove("success");
    el.textContent = template.replace(
      "{{amount}}",
      `$${remaining.toLocaleString()}`
    );
  }
}



   itemsEl.addEventListener("click", e => {
  const btn = e.target;
  const itemEl = btn.closest(".custom-cart-item");
  if (!itemEl) return;

  const sku = itemEl.dataset.sku;
  const cart = getCart();
  const item = cart.items.find(i => i.sku === sku);
  if (!item) return;

  if (btn.dataset.action === "increase") {
    item.qty += 1;
  }

  if (btn.dataset.action === "decrease") {
    item.qty -= 1;
    if (item.qty <= 0) {
      cart.items = cart.items.filter(i => i.sku !== sku);
    }
  }

  if (btn.classList.contains("remove-item")) {
    cart.items = cart.items.filter(i => i.sku !== sku);
  }

  saveCart(cart);
});


itemsEl.addEventListener("change", e => {
  if (!e.target.classList.contains("qty-input")) return;

  const itemEl = e.target.closest(".custom-cart-item");
  const sku = itemEl.dataset.sku;
  const cart = getCart();
  const item = cart.items.find(i => i.sku === sku);

  const value = parseInt(e.target.value, 10);
  item.qty = value > 0 ? value : 1;

  saveCart(cart);
});
overlay.addEventListener("click", () => {
  closeCart();
});

drawer.addEventListener("click", e => {
  e.stopPropagation();
});



    renderCart();
    updateCartBadge();

    const cart = getCart();



  }

  // 🔥 ESPERA AL DOM REAL
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initExternalCart);
  } else {
    initExternalCart();
  }
  
})();





document.querySelector(".cart-checkout").addEventListener("click", async e => {
  e.preventDefault();

  const cart = JSON.parse(localStorage.getItem("externalCart"));
  if (!cart || !cart.items.length) return;
  console.log("📤 Enviando carrito:", cart);


  const res = await fetch(
    "https://us-central1-masca-51862.cloudfunctions.net/api/mp/create",
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(cart)
    }
  );

  const { cartId } = await res.json();

  window.location.href =
    `https://masca-dashboard.onrender.com/checkout?cartId=${cartId}`;
});
